import Cookies from 'js-cookie';

class CookieStorage {
    constructor(namespace: string, options: Cookies.CookieAttributes) {
        this.namespace = namespace || null;
        this.options = options;
    }

    namespace: string;
    options: Cookies.CookieAttributes;

    setItem(key: string, value: string | object) {
        Cookies.set(this._getStorageKey(key), value, this.options);
    }

    getItem(key) {
        return Cookies.get(this._getStorageKey(key));
    }

    removeItem(key) {
        Cookies.remove(this._getStorageKey(key));
    }

    _getStorageKey(key) {
        if (this.namespace) {
            return [this.namespace, key].join('.')
        }
        return key;
    }
}

export default CookieStorage

